import ManagePatientModal from '@/components/dashboard/liste-patients/manage-patient'
import store_patient from "@/store/mods/clinique/patients"


export default {
    name: 'liste-patients',
    components: {
        ManagePatientModal
    },
    props: [],
    data() {
        return {
            l_is_loading: true,
            l_is_empty: false,

            fields: [
                { key: 'patient_code', label: 'Numéro de dossier' }, 
                { key: 'patient_nom', label: 'Patient' }, 'sexe', 
                { key: 'age', label: 'Âge' },  'patient_telephone',
                'assurance', 'action.s'
            ],
            patient_filter: "",
            perPage: -1,
            currentPage: 1,
            total_pages: 0,

            patient_id: 0,
            liste_all_patients: [],
            toggler: 0,
            search_filter: {
                with_consultation: false
            }
        }
    },

    watch: {
        patient_filter() {
            if (this.patient_filter == '') {
                this.search_filter.search_term = ''
                this.refreshListePatient()
            }
        }  
    },

    computed: {
        
    },

    mounted() {
        this.refreshListePatient()
    },

    methods: {
        handleSearch() {
            this.currentPage = 1
            this.search_filter.search_term = this.patient_filter
            this.refreshListePatient()
        },

        refreshListePatient() {
            this.l_is_loading = true
            this.liste_all_patients = []

            store_patient.getListeAllPatient(this.search_filter).then((patients) => {
                this.liste_all_patients = patients.data
                this.total_pages = patients.last_page
                if (this.liste_all_patients.length > 0) {
                    this.l_is_empty = false
                } else {
                    this.l_is_empty = true
                }
                this.l_is_loading = false
            })
        },

        setPatientToEdit(patient_id) {
            this.patient_id = parseInt(patient_id),
            this.toggler = (this.toggler == 0)?1:0
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.search_filter.page = this.currentPage
                this.refreshListePatient()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.search_filter.page = this.currentPage
                this.refreshListePatient()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.search_filter.page = this.currentPage
                this.refreshListePatient()
            }
        },

        searchPatient() {
            this.search_filter.search_term = this.patient_filter

            this.refreshListePatient()
        }
    }
}